import React from 'react';
import { FillLabel } from './FillLabel';
type Props = {
  href: string;
  tone?: 'light' | 'dark';
  className?: string;
};

/**
 * Download PDF action with the custom document mark (folded page, PDF tag, download stroke).
 * light = on navy (cream outline, cream fill on hover); dark = on light surfaces.
 */
export function PdfDownloadButton({
  href,
  tone = 'light',
  className = ''
}: Props) {
  const light = tone === 'light';
  return <a href={href} download className={`btn-fill group inline-flex h-[48px] items-center gap-3 whitespace-nowrap border px-5 font-accent text-[11px] uppercase tracking-[0.08em] ${light ? 'btn-fill-light border-cream/20 bg-cream/[0.06] text-cream/90' : 'btn-fill-dark border-ink/25 bg-ink/[0.03] text-ink/85'} ${className}`} data-id="element-320" data-mp="8ji8i81x5i7i">
      <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.1} strokeLinecap="square" className="relative z-[1] h-[22px] w-[22px] shrink-0" data-id="element-321" data-mp="1tv078gl2i6p1">
        <path d="M5.5 2.5h9l4 4v15h-13z" data-id="element-322" data-mp="1z848fq9ahbb7" />
        <path d="M14.5 2.5v4h4" data-id="element-323" data-mp="243rzycb8ugjv" />
        <rect x="2.5" y="10" width="11" height="6" fill="currentColor" stroke="none" className="opacity-90" data-id="element-324" data-mp="2430553ph0mun" />
        <text x="8" y="14.6" textAnchor="middle" fontSize="4.6" fontFamily="'Space Mono', monospace" letterSpacing="0.2" stroke="none" className={`transition-colors duration-300 ${light ? 'fill-[#18263f] group-hover:fill-[#f7f4ee]' : 'fill-white group-hover:fill-navy'}`} data-id="element-325" data-mp="291tfwoddhzr4">
          PDF
        </text>
        <path d="M15.5 12v6.5M13.5 16.5l2 2 2-2" className="transition-transform duration-300 group-hover:translate-y-[1px]" data-id="element-326" data-mp="1u6naa2i6w2yb" />
      </svg>
      <FillLabel data-id="element-327" data-mp="xo9675jwrc39">Download PDF</FillLabel>
    </a>;
}